import React from "react";
import { LogOut, Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "./assets/logo.png";
import { useAuth } from "./hooks/useAuth";

export default function MainHeader() {
  const [open, setOpen] = React.useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
  };

  const menuItems = [
    { name: "대시보드", path: "/app" },
    { name: "일정 관리", path: "/schedule_management" },
    { name: "E-Drive", path: "/edrive" },
    { name: "재정 관리", path: "/financial_management" },
    { name: "가이드", path: "/help_guide" },
    { name: "조직 관리", path: "/iam_dashboard" },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white/80 backdrop-blur-lg border-b border-gray-200 sticky top-0 z-50">
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* 로고 */}
          <div
            className="flex items-center gap-4 cursor-pointer"
            onClick={() => navigate("/app")}
          >
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-md">
              <img src={Logo} alt="elva logo" className="w-12 h-12" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Elva</h1>
          </div>

          {/* 중앙 네비게이션 - 화면 크기에 따라 동적으로 조정 */}
          <nav className="hidden md:flex items-center gap-0.5 lg:gap-1 absolute left-1/2 transform -translate-x-1/2">
            {menuItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`px-3 lg:px-4 xl:px-6 py-2 rounded-lg transition-all text-sm lg:text-base whitespace-nowrap ${
                  isActive(item.path)
                    ? "bg-blue-50 text-blue-700 font-medium"
                    : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                }`}
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* 로그아웃 버튼 */}
          <div className="flex items-center gap-4">
            <button
              onClick={handleLogout}
              className="hidden md:flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-50 rounded-lg transition-colors text-sm lg:text-base"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden lg:inline">로그아웃</span>
            </button>

            {/* 모바일 메뉴 버튼 */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-600 hover:text-gray-800"
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-1">
            {menuItems.map((item) => (
              <button
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-3 rounded-lg transition-all text-left ${
                  isActive(item.path)
                    ? "bg-blue-50 text-blue-700 font-medium"
                    : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                }`}
              >
                {item.name}
              </button>
            ))}
            <div className="border-t border-gray-200 pt-2 mt-2">
              <button
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <LogOut className="w-4 h-4" />
                로그아웃
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
